import { render, staticRenderFns } from "./Agenti.vue?vue&type=template&id=6f8363c2"
import script from "./Agenti.vue?vue&type=script&lang=js"
export * from "./Agenti.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports